var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[(_vm.pageReady === 'done')?_c('div',{staticClass:"w-100 h-100"},[_c('transition',{attrs:{"mode":"out-in"}},[_c('BlackPearlHome')],1)],1):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }